import { render } from "./ThirdPartyRouterView.vue?vue&type=template&id=18d51efe&scoped=true"
const script = {}

import "./ThirdPartyRouterView.vue?vue&type=style&index=0&id=18d51efe&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/正式_ls/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d51efe"]])

export default __exports__